import {htmlToText} from '@frontapp/editor-html';

import {DraftMessageModel} from '../models/api/messageModel';
import {RecipientRolesEnum} from '../models/api/recipientModel';
import {ApiTextCompletion} from '../models/api/textCompletionModel';
import {postApiAsync} from '../services/http/http';
import {splitName} from './nameSplitter';

export enum DraftAssistantToneOptionsEnum {
  PROFESSIONAL = 'Professional',
  FRIENDLY = 'Friendly',
  APOLOGETIC = 'Apologetic',
  FUNNY = 'Funny',
}

export interface DraftAssistantOptions {
  conversationId: number;
  tone: DraftAssistantToneOptionsEnum;
  draftMessage: DraftMessageModel | null;
  senderFirstName: string | null;
  companyUrl: string;
}

export async function autoGenerateDraft(options: DraftAssistantOptions) {
  const {tone, draftMessage, companyUrl, conversationId, senderFirstName} = options;

  // Find the recipient name
  const recipient = draftMessage && draftMessage.recipients.find((r) => r.role === RecipientRolesEnum.TO);
  const splitRecipientName = recipient && recipient.name && splitName(recipient.name);
  const recipientFirstName = splitRecipientName ? splitRecipientName.given : undefined;

  const draftText = draftMessage && draftMessage.html ? htmlToText(draftMessage.html) : '';

  const response = await postApiAsync(
    ApiTextCompletion,
    `${companyUrl}/conversations/${conversationId}/text_completion/draft`,
    {
      tone,
      draftText,
      senderFirstName,
      recipientFirstName,
    },
  );

  return response.completion;
}

export interface SummarizeConversationOptions {
  conversationId: number;
  companyUrl: string;
}

export async function summarizeConversation(options: SummarizeConversationOptions) {
  const response = await postApiAsync(
    ApiTextCompletion,
    `${options.companyUrl}/conversations/${options.conversationId}/text_completion/summarize`,
    {}, // Designed API as POST to support future options
  );

  return response.completion;
}
